import React from 'react'
import { graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
const axios = require('axios')
import Layout from '../../../components/layout'
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap'
import header from '../../../images/CleanAir-Desktop-Header-1920x340-Curve-DataHub-2x.png'
import headerMobile from '../../../images/CleanAir-Mobile-Header-1080x550-Curve-DataHub-2x.png'
import LinkBack from '../../../components/link-back'
import TurnstileCaptcha from '../../../components/turnstile-captcha'

class EmailSignUpTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 'form',
      zone: 'Bolton',
      alertday: 'today',
      postcode: '',
      email: '',
      year_of_birth: '',
      code: '',
      token: null,
      sentTo: null,
      error: false,
      message: null,
      submitting: false,
      captcha_token: '',
      captchaResetKey: 0,
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleVerify = this.handleVerify.bind(this)
    this.handleCaptchaVerify = this.handleCaptchaVerify.bind(this)
    this.handleCaptchaExpire = this.handleCaptchaExpire.bind(this)
    this.handleCaptchaError = this.handleCaptchaError.bind(this)
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name
    this.setState({
      [name]: value,
    })
  }

  handleCaptchaVerify(token) {
    this.setState({ captcha_token: token })
  }

  handleCaptchaExpire() {
    this.setState({ captcha_token: '' })
  }

  handleCaptchaError() {
    this.setState({
      captcha_token: '',
      error: true,
      message: 'Security check failed. Please try again.',
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    if (!this.state.captcha_token) {
      this.setState({
        error: true,
        message: 'Please complete the security check before submitting.',
      })
      return
    }

    this.setState({ submitting: true, error: false, message: null })
    axios
      .post('/.netlify/functions/subscribe', {
        action: 'start',
        zone: this.state.zone,
        mode: 'email',
        email: this.state.email,
        alertday: this.state.alertday,
        postcode: this.state.postcode,
        year_of_birth: this.state.year_of_birth,
        captcha_token: this.state.captcha_token,
      })
      .then(response => {
        if (response.data.status === 200) {
          this.setState({
            step: 'verify',
            token: response.data.token,
            sentTo: response.data.sentTo,
            submitting: false,
          })
          return
        }
        this.setState({
          error: true,
          message:
            response.data.message ||
            'An error has occurred, please try again later.',
          submitting: false,
          captcha_token: '',
          captchaResetKey: this.state.captchaResetKey + 1,
        })
      })
      .catch(err => {
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          'An error has occurred, please try again later.'
        this.setState({
          error: true,
          message,
          submitting: false,
          captcha_token: '',
          captchaResetKey: this.state.captchaResetKey + 1,
        })
      })
  }

  handleVerify(event) {
    event.preventDefault()
    this.setState({ submitting: true, error: false, message: null })
    axios
      .post('/.netlify/functions/subscribe', {
        action: 'verify',
        token: this.state.token,
        code: this.state.code,
      })
      .then(response => {
        if (response.data.status === 200) {
          this.setState({ step: 'success', submitting: false })
          return
        }
        this.setState({
          error: true,
          message:
            response.data.message ||
            'An error has occurred, please try again later.',
          submitting: false,
        })
      })
      .catch(err => {
        const message =
          (err.response && err.response.data && err.response.data.message) ||
          'An error has occurred, please try again later.'
        this.setState({ error: true, message, submitting: false })
      })
  }

  render() {
    const post = get(this.props, 'data.contentfulBasicPage')
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')

    return (
      <Layout location={this.props.location}>
        <div style={{ background: '#fff' }}>
          <Helmet title={`Subscribe to email alerts | ${siteTitle}`} />

          <div className="page-banner page-banner--disclaimer">
            <img className="d-none d-lg-block" src={header} alt="" />
            <img className="d-block d-lg-none" src={headerMobile} alt="" />{' '}
            <h1>Subscribe to email alerts</h1>
          </div>

          <Container className="news mb-5">
            <LinkBack
              to={'/data-hub/forecast-and-alerts'}
              title={'back to Forecast and alerts'}
            />

            <Row>
              <Col>
                <p>Receive air pollution email alerts by signing up below.</p>

                <p>
                  You’ll receive an email if the air pollution is predicted to
                  be moderate or above on the Daily Air Quality Index scale.
                </p>

                <p>
                  You can choose whether you want to receive email alerts for
                  the day ahead (which will be sent at approximately 7am) by
                  choosing ‘same day’, or the next day (which will send an alert
                  at approximately 7pm) by choosing ‘next day’.
                </p>
              </Col>
            </Row>
          </Container>

          <div className="subscribe-form pt-5 pb-5 mt-5">
            <Container>
              {this.state.step === 'form' && (
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label for="zone">Area *</Label>
                    <Input
                      type="select"
                      name="zone"
                      id="zone"
                      value={this.state.zone}
                      onChange={this.handleInputChange}
                      required
                    >
                      <option>Bolton</option>
                      <option>Bury</option>
                      <option>Manchester</option>
                      <option>Oldham</option>
                      <option>Rochdale</option>
                      <option>Salford</option>
                      <option>Stockport</option>
                      <option>Tameside</option>
                      <option>Trafford</option>
                      <option>Wigan</option>
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label for="alertday">Alert day *</Label>
                    <Input
                      type="select"
                      name="alertday"
                      id="alertday"
                      value={this.state.alertday}
                      onChange={this.handleInputChange}
                      required
                    >
                      <option value="today">Same day</option>
                      <option value="tomorrow">Next day</option>
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="year_of_birth">Year of birth</Label>
                    <Input
                      max="2018"
                      min="1900"
                      type="number"
                      name="year_of_birth"
                      id="year_of_birth"
                      maxlength="4"
                      minlength="4"
                      value={this.state.year_of_birth}
                      onChange={this.handleInputChange}
                    ></Input>
                  </FormGroup>

                  <FormGroup>
                    <Label for="postcode">Postcode</Label>
                    <Input
                      type="text"
                      name="postcode"
                      id="postcode"
                      value={this.state.postcode}
                      onChange={this.handleInputChange}
                    ></Input>
                  </FormGroup>

                  <FormGroup>
                    <Label for="email">Email *</Label>
                    <Input
                      type="text"
                      name="email"
                      id="email"
                      value={this.state.email}
                      onChange={this.handleInputChange}
                      required
                    ></Input>
                  </FormGroup>

                  <FormGroup>
                    <Label>Security check *</Label>
                    <TurnstileCaptcha
                      siteKey={process.env.GATSBY_TURNSTILE_SITE_KEY}
                      resetKey={this.state.captchaResetKey}
                      onVerify={this.handleCaptchaVerify}
                      onExpire={this.handleCaptchaExpire}
                      onError={this.handleCaptchaError}
                    />
                  </FormGroup>

                  {this.state.error && (
                    <Alert color="danger">{this.state.message}</Alert>
                  )}
                  <button
                    className="btn btn-content"
                    type="submit"
                    disabled={
                      this.state.submitting || !this.state.captcha_token
                    }
                  >
                    {this.state.submitting ? 'Sending...' : 'Submit'}
                  </button>
                </Form>
              )}
              {this.state.step === 'verify' && (
                <Form onSubmit={this.handleVerify}>
                  <p>
                    We've sent a 6-digit verification code by email to{' '}
                    <b>{this.state.sentTo}</b>. Enter it below to confirm your
                    subscription. The code expires in 10 minutes.
                  </p>
                  <FormGroup>
                    <Label for="code">Verification code *</Label>
                    <Input
                      type="text"
                      name="code"
                      id="code"
                      inputMode="numeric"
                      pattern="[0-9]{6}"
                      maxLength="6"
                      autoComplete="one-time-code"
                      value={this.state.code}
                      onChange={this.handleInputChange}
                      required
                    />
                  </FormGroup>
                  {this.state.error && (
                    <Alert color="danger">{this.state.message}</Alert>
                  )}
                  <button
                    className="btn btn-content"
                    type="submit"
                    disabled={this.state.submitting}
                  >
                    {this.state.submitting ? 'Verifying...' : 'Confirm'}
                  </button>
                </Form>
              )}
              {this.state.step === 'success' && (
                <div>
                  <h2>Success</h2>
                  <p>You have successfully subscribed</p>
                </div>
              )}
              <div className="pt-5 mt-5">
                <p>
                  By subscribing you are agreeing to our{' '}
                  <Link to="/forecasting-alerts-terms-and-conditions">
                    terms and conditions
                  </Link>
                  .
                </p>

                <p>
                  You can unsubscribe at anytime by going to our{' '}
                  <Link to="/data-hub/forecast-and-alerts/unsubscribe">
                    unsubscribe page
                  </Link>
                  .{' '}
                </p>

                <p>
                  The information you provide on this form will be used for the
                  purpose of providing you with air quality alerts by your
                  chosen method (either email or text message). It will also be
                  used for evaluation of the take up of the air quality alerts
                  scheme.
                </p>
                <p>
                  Transport for Greater Manchester (TfGM) process your personal
                  data for the purpose of providing you with air quality alerts
                  with your consent. We process your postcode and year of birth
                  for the purpose of evaluating the take up of the scheme, and
                  this is necessary for the performance of a task in the public
                  interest, namely fulfilling our duty under s99 of the Local
                  Transport Act 2008 to improve the environmental wellbeing of
                  Greater Manchester
                </p>
                <p>
                  Your personal data will be held until you opt out of receiving
                  alerts, when it will be deleted. If we end the scheme we will
                  delete your data on closure of the scheme.
                </p>
                <p>
                  Information on exercising your rights under data protection
                  law as well as more information about how we process your
                  personal data can be found in our Privacy Policy on the TfGM
                  website at.
                  <a href="http://tfgm.com/privacy-policy">
                    http://tfgm.com/privacy-policy
                  </a>
                </p>
                <p>
                  You can contact the Data Protection Officer by emailing{' '}
                  <a href="mailto:data.protection@tfgm.com">
                    data.protection@tfgm.com
                  </a>
                  .
                </p>
              </div>
            </Container>
          </div>
        </div>
      </Layout>
    )
  }
}

export default EmailSignUpTemplate

export const pageQuery = graphql`
  query EmailSignUpPageBySlug {
    site {
      siteMetadata {
        title
      }
    }
  }
`
